import React from 'react';

export const OPEN_PRIVACY_CHOICES_EVENT = 'treas:open-privacy-choices';

export default function PrivacyChoicesLink() {
  return (
    <button
      type="button"
      className="privacy-choices-inline"
      aria-haspopup="dialog"
      onClick={() => window.dispatchEvent(new Event(OPEN_PRIVACY_CHOICES_EVENT))}
    >
      Privacy choices
    </button>
  );
}
